export default __webpack_public_path__ + "static/media/compare.83ad0953.png";